// ---------------------------------------------------------------------------
// Sprint 3 A8: Canned Responses
// ---------------------------------------------------------------------------

import { pgTable, uuid, text, integer, boolean, timestamp, index, uniqueIndex } from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

export const cannedResponses = pgTable(
  "canned_responses",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    title: text("title").notNull(),
    body: text("body").notNull(),
    category: text("category"), // e.g., "greeting", "support", "closing"
    shortcut: text("shortcut"), // e.g., "thanks", "followup" (for /command trigger)
    isShared: boolean("is_shared").default(true).notNull(), // shared (all agents) vs personal
    createdBy: text("created_by").notNull(), // userId
    usageCount: integer("usage_count").default(0).notNull(),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_canned_responses_tenant").on(table.tenantId),
    uniqueIndex("uq_canned_responses_shortcut").on(table.tenantId, table.shortcut),
    index("idx_canned_responses_category").on(table.tenantId, table.category),
  ],
);
